import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      © 2025 Clean Service Pro - Tous droits réservés.
    </footer>
  );
}